/** Title for duplicate-skip UI (list banner, CSV modal, inline messages). */
export const DUPLICATE_CONTACTS_SKIPPED_TITLE = 'Duplicate Contacts Skipped';

/** How long duplicate-skip notices stay visible before auto-dismiss (ms). */
export const DUPLICATE_SKIP_NOTICE_DISPLAY_MS = 25000;

/** Pull "N" from API reason text like "within the last 1 day." */
export function parseDuplicateWindowDaysFromReasons(blockedList) {
    if (!Array.isArray(blockedList)) return null;
    for (let i = 0; i < blockedList.length; i += 1) {
        const r = blockedList[i]?.reason;
        if (!r || typeof r !== 'string') continue;
        const m = r.match(/within the last (\d+)\s*day/i);
        if (m) {
            const n = parseInt(m[1], 10);
            if (!Number.isNaN(n) && n >= 1) return n;
        }
    }
    return null;
}

/**
 * Window length for messaging: prefer campaign duplicate rule when enabled and valid;
 * otherwise parse from API reason strings on blocked rows.
 */
export function getDuplicateSkipWindowDays(campaignLike, blockedList) {
    let windowDays = null;
    if (campaignLike?.duplicate_data_rule_enabled) {
        const d = parseInt(campaignLike.duplicate_data_rule_days, 10);
        if (!Number.isNaN(d) && d >= 1) windowDays = d;
    }
    if (windowDays == null) windowDays = parseDuplicateWindowDaysFromReasons(blockedList);
    return windowDays;
}

/** Body only (no title). Same wording as the list / form duplicate-skip banner. */
export function formatDuplicateSkippedBody(count, windowDays) {
    if (count == null || count < 1) return '';
    if (windowDays != null) {
        const unit = windowDays === 1 ? 'day' : 'days';
        if (count === 1) {
            return `1 contact was not added because it already exists in the campaign within the last ${windowDays} ${unit}. You can try adding it again after this period.`;
        }
        return `${count} contacts were not added because they already exist in the campaign within the last ${windowDays} ${unit}. You can try adding them again after this period.`;
    }
    if (count === 1) {
        return '1 contact was not added because it already exists in the campaign under your duplicate rule. You can try adding it again after the duplicate period has passed.';
    }
    return `${count} contacts were not added because they already exist in the campaign under your duplicate rule. You can try adding them again after the duplicate period has passed.`;
}

/** Title + body for modals or appended success text. */
export function formatDuplicateSkippedNotice(count, windowDays) {
    const body = formatDuplicateSkippedBody(count, windowDays);
    if (!body) return '';
    return `${DUPLICATE_CONTACTS_SKIPPED_TITLE}. ${body}`;
}
